import { useEffect } from 'react'
import { GET_PAGES, SET_PAGES, SET_PAGES_PAGINATION } from '../store/actions'
import { dispatchPageBusEvent } from 'client/common/pageBus'

const POLL_INTERVAL_MS = 100
const MAX_WAIT_MS = 1000

export const useAlgoliaOverviewData = ({ dispatchPages, isPaginated }, enabled) => {
  useEffect(() => {
    if (!enabled) return

    dispatchPages({ type: GET_PAGES, page: 1, reset: true })

    let elapsed = 0

    const interval = setInterval(() => {
      const response = window?.__PRELOADED_STATE_listerFragment__?.content?.response

      if (response) {
        clearInterval(interval)
        dispatchPages({
          type: isPaginated ? SET_PAGES_PAGINATION : SET_PAGES,
          pages: response.results,
          totalNumberOfResults: response.totalNumberOfResults,
          page: 1,
          reset: true
        })
        dispatchPageBusEvent({ type: 'SOFT_CONTENT_SEARCH_RENDERED', props: { count: response?.totalNumberOfResults } })
        return
      }

      elapsed += POLL_INTERVAL_MS

      if (elapsed >= MAX_WAIT_MS) {
        clearInterval(interval)
        dispatchPages({
          type: isPaginated ? SET_PAGES_PAGINATION : SET_PAGES,
          pages: [],
          totalNumberOfResults: 0,
          page: 1,
          reset: true
        })
      }
    }, POLL_INTERVAL_MS)

    return () => clearInterval(interval)
    // eslint-disable-next-line
  }, [enabled])
}
